import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#basic-multiple-select" }),
  /*#__PURE__*/_createTextVNode(" Basic multiple select ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Basic multiple select ", -1)
const _hoisted_4 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_select, {
        modelValue: _ctx.value1,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value1 = $event)),
        multiple: "",
        placeholder: "Select"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "1",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "2",
            value: 2
          }),
          _createVNode(_component_el_option, {
            label: "3",
            value: 3
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createTextVNode(" " + _toDisplayString(_ctx.value1) + " ", 1),
      _createVNode(_component_el_select, {
        modelValue: _ctx.value2,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.value2 = $event)),
        multiple: "",
        "collapse-tags": "",
        style: {"margin-left":"20px"},
        placeholder: "Select"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_Fragment, null, _renderList(10, (i) => {
            return _createVNode(_component_el_option, {
              key: i,
              label: i,
              value: i
            }, null, 8, ["label", "value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code5), 1)
        ]),
        _: 1
      })
    ])
  ]))
}